import axios from "axios";

export const REGISTRATION_DATA_URL = "/registration/getRegistrationData";
export const GET_REGISTRATION_DATA_FILE = "/registration/getRegistrationGridDataForExcel";

export function findRegistrationData(queryParams) {
  return axios.get(REGISTRATION_DATA_URL, {params: queryParams} );
}
export function getRegistrationDataFile(queryParams) {
  return axios.get(GET_REGISTRATION_DATA_FILE, {params: queryParams});
}
